import { transformDateValue } from 'core/js/FormUtils';
export const getCompositionView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let compositionList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Name","fieldValue":transformDataValue(data.name,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          compositionList.push(card);
  })
  return compositionList;
}